import { Module } from "../lib/modules";
import { StateManager } from "../lib/stateManager";

interface ImageSkeletonState {
  managedElements: Set<Element>;
  skeleton: (container: Element) => void;
}

export const ImageSkeleton: Module<ImageSkeletonState> = () => {
  // Create a state manager with initial state
  const state = new StateManager<ImageSkeletonState>({
    managedElements: new Set<Element>(),
    skeleton: () => {}
  });

  const init = () => {
    attachEventListeners();

    // Allows other modules to access the attachEventListeners function
    state.set("skeleton", skeleton);
  };

  const skeleton = (container: Element) => {
    if (state.get("managedElements").has(container)) {
      return; // Skip if already managed
    }

    state.get("managedElements").add(container);

    const image = container.querySelector("img");
    const video = container.querySelector("video");

    if (image && image instanceof HTMLImageElement) {
      // Handle images
      if (image.complete) {
        container.classList.remove("skeleton");
      } else {
        image.addEventListener("load", () => {
          container.classList.remove("skeleton");
        });
      }
    } else if (video && video instanceof HTMLVideoElement) {
      // Handle videos
      if (video.readyState >= 2) {
        // HAVE_CURRENT_DATA or higher
        container.classList.remove("skeleton");
      } else {
        video.addEventListener("loadeddata", () => {
          container.classList.remove("skeleton");
        });
      }
    }
  };

  const attachEventListeners = () => {
    const elements = document.querySelectorAll(".skeleton");

    for (const container of elements) {
      skeleton(container);
    }
  };

  const detachEventListeners = () => {};

  const destroy = () => {
    detachEventListeners();
  };

  return {
    init,
    attachEventListeners,
    detachEventListeners,
    destroy,
    state,
    name: "imageSkeleton"
  };
};
